<script>
	import { filedrop } from "filedrop-svelte";
	import { field, form } from "svelte-forms";
	import { required } from "svelte-forms/validators";
	import { Button, Col, Image, Row } from "sveltestrap";
	import PageHeader from "../../../../../../src/components/PageHeader/PageHeader.svelte";
	import { api, convert } from "../../../../../../src/services/helpers";
	import {
		DynamicComponent,
		loadSpinner,
	} from "../../../../../../src/store/store";
	import {
		damageAreaOptions,
		damageCategory,
		damageTypeOptions,
		driveDamageTypeOptions,
	} from "../../../../../../src/utils/options";
	import {
		extractErrorMessage,
		splitImageUrl,
	} from "../../../../../utils/misc";

	let files;
	let options = {
		fileLimit: 10,
		multiple: true,
	};

	export let issues;

	export function handleClick() {
		DynamicComponent.set(1);
	}

	let preview = [];
	let uploadedImg = [];
	let fileImg = [];

	const onFileSelected = (e) => {
		files = e.detail.files;
		let reader;
		let result = [];

		for (let index = 0; index < files.accepted.length; index++) {
			reader = new FileReader();

			if (files) {
				reader.readAsDataURL(files.accepted[index]);
				reader.onload = (e) => {
					result.push(e.target.result);
					preview = [...result];
					uploadedImg.push(files.accepted[index]);
					fileImg = [...uploadedImg];
				};
			}
		}
	};

	let selection = [];
	let imageUrls = [];
	$: filtered = fileImg.filter((el, i) => selection.some((j) => i == j));

	const reportSection = field("damageCategory", issues.reportSection, [
		required(),
	]);
	const damageArea = field("damageArea", issues.carSection, [required()]);
	const damageType = field("damageType", issues.damageType, [required()]);
	const damageImpact = field("damageImpact", "", [required()]);
	const quotation = field("quotation", "", [required()]);
	const myForm = form(
		damageImpact,
		reportSection,
		damageArea,
		damageType,
		quotation
	);
	let load = false;
	let isCreate = false;
	const handleApprove = async () => {
		try {
			load = true;
			loadSpinner.set(true);
			const formData = new FormData();
			formData.append("SourceTable", issues.source);
			formData.append("Impact", $damageImpact.value);
			formData.append("Quotation", $quotation.value);
			formData.append("ReportSection", $reportSection.value);
			formData.append("VehicleId", issues.vehicleId);
			formData.append("Description", issues.description);
			formData.append("TripStatus", issues.tripStatus);
			formData.append("ReportedIssueId", issues.issueId);
			formData.append("ReportedAt", issues.dateReported);
			formData.append(
				"CarSection",
				$reportSection.value == "Exterior" ? $damageArea.value : "-"
			);
			formData.append("DamageType", $damageType.value);
			if (imageUrls.length > 0) {
				for (let i = 0; i < imageUrls.length; i++) {
					formData.append("ImageUrls", splitImageUrl(imageUrls[i]));
				}
			}

			for (let i = 0; i < filtered.length; i++) {
				formData.append("NewImages", filtered[i]);
			}

			const createNewIssue = await api(
				"/v0/Issue/v2/CreateIssue",
				"Tasking",
				"POST",
				formData,
				{},
				localStorage.getItem("token"),
				"multipart"
			);

			if (createNewIssue.data.error_code == 201) {
				load = false;
				loadSpinner.set(false);
				DynamicComponent.set(4);

				setTimeout(function () {
					DynamicComponent.set(1);
				}, 3000);
			}
		} catch (err) {
			extractErrorMessage(err);
			load = false;
			loadSpinner.set(false);
		}
	};
</script>

<Row class="me-3 ">
	<Col xs={12}>
		<div>
			<Col>
				<Row class="border-detail ">
					<Col xs={12} class="d-flex justify-content-between g-0">
						<div class="mt-3 ms-4">
							<PageHeader title="Split Issue" />
						</div>
						<div class="link">
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<p
								on:click={() => handleClick()}
								class="btn btn-danger mx-2 my-2"
								style="border-radius: 7px !important;"
							>
								<b>X</b>
							</p>
						</div>
					</Col>
					<Col xs={12} class="mt-2 px-2 mx-2">
						<Col
							xs={12}
							class="d-flex justify-content-start px-2 mx-2"
						>
							<div>
								<h4>
									{issues.vehicleMake +
										" " +
										issues.vehicleModel +
										" " +
										issues.vehicleNumber}
								</h4>
							</div>
						</Col>
						<Col
							xs={6}
							class="d-flex justify-content-start px-2 mx-2"
						>
							<div class="me-2">
								<p class="status-bar-info status-bar-info-1">
									Color: {issues.vehicleColor}
								</p>
							</div>
						</Col>
					</Col>
					<Col>
						<Row class="carousel-detail-upload me-3 mb-4 ">
							<Col class="row d-flex">
								<div class="mt-4 mx-2">
									<div
										use:filedrop={options}
										on:filedrop={(e) => onFileSelected(e)}
										type="file"
										class="filedrop"
									>
										<img
											src="/assets/add-image.png"
											style="width:40px; height:40px;"
											alt="img"
										/>
										<Button
											class="customButtonUpload primary-blue my-2"
											>Select Photos</Button
										>
										<p>
											<b>or drag up to 10 photos here</b>
										</p>
									</div>

									<div class="my-2">
										{#if files}
											{#each preview as src, index}
												<div
													class="container-checkbox"
													style="height:auto; border: 0px !important; padding: 5px !important;
                                            outline: 0 !important;"
												>
													<Image
														{src}
														style="width:100%; height:230px; object-fit: cover;"
														alt="vehicle image"
													/>
													<input
														type="checkbox"
														class="checkbox"
														value={index}
														bind:group={selection}
													/>
												</div>
											{/each}
										{/if}

										{#each issues.imageUrls as image, index}
											<div
												class="container-checkbox mb-2"
												style="height:auto; border: 0px !important; padding: 5px !important;
                                            outline: 0 !important;"
											>
												<Image
													src={image}
													style="width:100%; height:230px; object-fit: cover;"
													alt="img"
												/>
												<input
													type="checkbox"
													class="checkbox"
													value={image}
													bind:group={imageUrls}
												/>
											</div>
										{/each}
									</div>
								</div>
								{#if imageUrls.length == 0 && filtered.length == 0}
									<Row>
										<div class="mx-2">
											<p class="error-text">
												Please select at least one
												photo!
											</p>
										</div>
									</Row>
								{/if}
							</Col>
						</Row>
					</Col>
					<Col xxl={12}>
						<Row class="my-3 mx-2">
							<Col xs={12}><span><b>Category</b></span></Col>
							<Col xs={9}>
								<select
									type="text"
									class="form-select getgo select my-3 mx-2"
									bind:value={$reportSection.value}
								>
									{#each damageCategory as option}
										<option value={option.value}>
											{option.label}</option
										>
									{/each}
								</select>
							</Col>
						</Row>
						{#if $reportSection.value == "Exterior"}
							<Row class="my-3 mx-2">
								<Col xs={12}
									><span><b>Damage Area</b></span></Col
								>
								<Col xs={9}>
									<div>
										{#each damageAreaOptions as { name, value, label }, key}
											<label
												key={`option-${name}-${
													key + 1
												}`}
												class="customCheckbox-new ms-2"
											>
												<input
													type="radio"
													{name}
													{value}
													class="d-none input"
													bind:group={$damageArea.value}
												/>
												<span
													class="customCheckbox-content-new py-1 my-2"
												>
													{label}
												</span>
											</label>
										{/each}
									</div>
								</Col>
							</Row>
						{/if}

						{#if $reportSection.value == "Exterior"}
							<Row class="my-3 mx-2">
								<Col xs={12}
									><span><b>Damage Type</b></span></Col
								>
								<Col xs={9}>
									<div>
										{#each damageTypeOptions as { name, value, label }, key}
											<label
												key={`option-${name}-${
													key + 1
												}`}
												class="customCheckbox-new ms-2"
											>
												<input
													type="radio"
													{name}
													{value}
													class="d-none input"
													bind:group={$damageType.value}
												/>
												<span
													class="customCheckbox-content-new py-1 my-2"
												>
													{label}
												</span>
											</label>
										{/each}
									</div>
								</Col>
							</Row>
						{:else if $reportSection.value == "Drive"}
							<Row class="my-3 mx-2">
								<Col xs={12}
									><span><b>Damage Type</b></span></Col
								>
								<Col xs={9}>
									<div>
										{#each driveDamageTypeOptions as { name, value, label }, key}
											<label
												key={`option-${name}-${
													key + 1
												}`}
												class="customCheckbox-new ms-2"
											>
												<input
													type="radio"
													{name}
													{value}
													class="d-none input"
													bind:group={$damageType.value}
												/>
												<span
													class="customCheckbox-content-new py-1 my-2"
												>
													{label}
												</span>
											</label>
										{/each}
									</div>
								</Col>
							</Row>
						{/if}
						<Row class="my-3 mx-2">
							<Col xs={12}>
								<span class=""> <b>Damage Impact*</b></span>
							</Col>
							<Col xs={12}>
								<div class="form-check mt-3 mx-2">
									<input
										class="form-check-input"
										type="radio"
										name="flexRadioDefault"
										id="split-impact-minor"
										value="0"
										bind:group={$damageImpact.value}
									/>
									<label
										class="form-check-label"
										for="split-impact-minor"
									>
										VQP 0
									</label>
								</div>
								<div class="form-check mx-2">
									<input
										class="form-check-input"
										type="radio"
										name="flexRadioDefault"
										id="split-impact-moderate"
										value="1"
										bind:group={$damageImpact.value}
									/>
									<label
										class="form-check-label"
										for="split-impact-moderate"
									>
										VQP 1
									</label>
								</div>
								<div class="form-check mx-2">
									<input
										class="form-check-input"
										type="radio"
										name="flexRadioDefault"
										id="split-impact-severe"
										value="2"
										bind:group={$damageImpact.value}
									/>
									<label
										class="form-check-label"
										for="split-impact-severe"
									>
										VQP 2
									</label>
								</div>
							</Col>
							{#if $myForm.hasError("damageImpact.required")}
								<Row>
									<div class="mx-2">
										<p class="error-text">
											Please select impact!
										</p>
									</div>
								</Row>
							{/if}
						</Row>
						<Row class="my-3 mx-2">
							<Col xs={12}>
								<span class=""> <b>Quotation</b></span>
							</Col>
							<Col xs={12}>
								<div class="form-check mt-3 mx-2">
									<input
										class="form-check-input"
										type="radio"
										name="quotation"
										id="SplitQuotationP"
										value="Pending"
										on:change={() => (isCreate = false)}
										bind:group={$quotation.value}
									/>
									<label for="SplitQuotationP">
										Pending
									</label>
								</div>
								<div class="form-check mx-2">
									<input
										class="form-check-input"
										type="radio"
										name="quotation"
										id="SplitQuotationC"
										value={true}
										on:change={quotation.reset}
										bind:group={isCreate}
									/>
									<label for="SplitQuotationC">
										Create
									</label>
								</div>
							</Col>
							{#if isCreate}
								<Col xs={8}>
									<textarea
										type="text"
										bind:value={$quotation.value}
										style="height: 150px;"
										placeholder="Start typing your quotation"
										class="form-control getgo input ms-2 mt-2"
									/>
								</Col>
							{/if}
						</Row>
						<Row class="my-3 mx-2">
							<Col xs={12}><span><b>Date reported</b></span></Col>
							<Col xs={12}>
								<p class="my-3 mx-2">
									{convert(issues.dateReported)}
								</p>
							</Col>
						</Row>
					</Col>
					<Row>
						<Col class="d-flex justify-content-end mb-4 mx-2">
							<div class="mx-2">
								<Button
									class="primary-white"
									on:click={() => handleClick()}
									>Cancel</Button
								>
							</div>
							<div class="mx-2">
								{#if load}
									<div class="">
										<Button
											class="primary-blue"
											type="button"
											disabled
										>
											<output
												class="spinner-grow spinner-grow-sm"
												aria-hidden="true"
											/>
											Loading...
										</Button>
									</div>
								{:else}
									<span class="">
										<Button
											class="primary-blue "
											on:click={myForm.validate}
											on:click={() => handleApprove()}
										>
											Approve
										</Button>
									</span>
								{/if}
							</div>
						</Col>
					</Row>
				</Row>
			</Col>
		</div>
	</Col>
</Row>

<style>
	:global(.border-detail) {
		border: 0.5px solid gray;
		margin-left: 0px !important;
		border-radius: 10px;
		/* overflow: hidden; */
		box-shadow: 0px 0px 1px 1px rgba(154, 146, 146, 0.5);
	}
	:global(.carousel-detail-upload) {
		border: 0.5px solid gray;
		margin-left: 20px !important;
		margin-right: 20px !important;
		padding-left: 10px;
		border-radius: 0.375rem;
		overflow: hidden;
		/* box-shadow: 0px 0px 1px 1px rgba(154, 146, 146, 0.5); */
	}
	:global(.customButtonUpload) {
		padding: 6px 10px !important;
		font-weight: bold !important;
		border: 0 !important;
		min-width: 150px !important;
	}
	.filedrop {
		background-color: #f0f0f0;
		height: 300px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border-radius: 0.375rem;
		border: 0.3em dashed #c3c3c3;
		outline: 1em solid #f0f0f0;
		transition: border 0.3s ease-in-out;
		outline-offset: -1.3em;
		padding: 1rem 1rem 1rem 1rem;
	}
	.filedrop:focus {
		border-color: #2196f3;
	}
	.filedrop:hover {
		border-color: #343434;
	}
	.container-checkbox {
		position: relative;
		float: left;
		width: 33.3%;
		padding: 5px;
	}
	.checkbox {
		position: absolute;
		top: 15px;
		right: 15px;
		transform: scale(1.5);
	}
</style>
